app.directive('googleAddressesAutocomplete', function ($timeout) {
    return {
        require: 'ngModel',
        link: function ($scope, element, attrs, model) {
            // var model = element.attr('ng-model');
            var autocomplete = new google.maps.places.Autocomplete(element[0], {
                types: ['establishment'],
            });

            google.maps.event.addListener(autocomplete, 'place_changed', function () {
                $scope.$apply(function () {
                    model.$setViewValue(autocomplete.getPlace());
                });
            });
        }
    };
});